import {ShapeLineStyle} from '@dv5/domain'
import {SVGProps} from 'react'

export const getShapeLineStyle = (value: unknown): ShapeLineStyle =>
    value === ShapeLineStyle.DOTTED || value === ShapeLineStyle.DASHED ? value : ShapeLineStyle.SOLID

export const getShapeStrokeProps = (
    lineStyle: unknown,
    borderWidth: number,
): Pick<SVGProps<SVGElement>, 'strokeDasharray' | 'strokeLinecap'> => {
    switch (getShapeLineStyle(lineStyle)) {
        case ShapeLineStyle.DOTTED:
            return {strokeDasharray: `0 ${borderWidth * 3}`, strokeLinecap: 'round'}
        case ShapeLineStyle.DASHED:
            return {strokeDasharray: `${borderWidth * 4} ${borderWidth * 2}`, strokeLinecap: 'butt'}
        default:
            return {strokeDasharray: undefined, strokeLinecap: 'butt'}
    }
}
